export interface IBase {
    CreatedBy: string;
    DateCreated: string;
    ModifiedBy: string;
    DateModified: string;
    isActiveFlag?;
}

export class Base implements IBase {
    CreatedBy: string;
    DateCreated: string;
    ModifiedBy: string;
    DateModified: string;
    responseCode?: string;
    responseStatus?: string;
    isActiveFlag?: any;
    constructor() {
    }
}
